@if (gesprekEvent.deelnemerId | profiel | async; as profiel) {
  <p class="text-n-600 w-full text-center typo-body variant-body-small py-2" role="alert">
    <span class="font-medium"> {{ profiel | profielnaam }} </span> heeft het gesprek verlaten.
  </p>
}

<!-- TODO: UX Copy gesprek aan JSON toevoegen -->
